import React from 'react';
import cx from 'classnames';

import { MDText } from 'i18n-react';

import { HomeIcon, IconText, InfoIcon, PaymentSpeedIcon } from '@motorway/mw-highway-code';
import { LoadingIndicator } from '@motorway/mw-highway-code/alpha';

import { APIResponseStatus } from 'Services/api.types';

import { useSaleDetailsSub } from '../../../vehicleCollection/hooks/useSaleDetailsSub';
import { useVehicleCollectionSub } from '../../../vehicleCollection/hooks/useVehicleCollectionSub';
import { MotorwayOfferType } from '../../../vehicleCollection/VehicleCollectionSubjects.types';
import { PreferenceStatus } from '../CollectionPreferences/collectionPreferences.types';
import { DealerDetailsSidePanelRow } from '../DealerDetailsSidePanelRow/DealerDetailsSidePanelRow';

import LocalTexts from './PlateAndCollectionSummary.texts.json';

import styles from './PlateAndCollectionSummary.scss';

const LocalT = new MDText(LocalTexts);

export const PlateAndCollectionSummary = () => {
  const { collectionPreferences, offer, offerStatus } = useVehicleCollectionSub();
  const { hasNegativeEquity } = useSaleDetailsSub();
  const { loading: preferencesLoading, status } = collectionPreferences ?? {};

  const isLoading = offerStatus === APIResponseStatus.LOADING || preferencesLoading;

  const { data } = offer as MotorwayOfferType ?? {};

  const { keepPrivatePlate = false, privatePlate = false } = data?.basic_details ?? {};

  const dealerDirect = status !== PreferenceStatus.NOT_REQUESTED;

  return (
    <div className={cx(styles.saleDetails, { [styles.loading]: isLoading })}>
      <h5 className={styles.heading}>
        {LocalT.translate('saleInfo')}
      </h5>
      <ul className={styles.details}>
        <DealerDetailsSidePanelRow />
        {hasNegativeEquity && <li>
          <IconText icon={PaymentSpeedIcon} text={LocalT.translate('negativeEquityInfo')} variant='small--regular' />
        </li>}
        {privatePlate && <li>
          <IconText icon={() => <InfoIcon filled={false} />} text={LocalT.translate(`keepPrivatePlate.${keepPrivatePlate}`)} variant='small--regular' />
        </li>}
        <li>
          <IconText icon={HomeIcon} text={LocalT.translate(`dealerCollection.${dealerDirect}`)} variant='small--regular' />
        </li>
      </ul>
      {isLoading && <LoadingIndicator size="large" />}
    </div>
  );
};
